import React from 'react';
import styled from 'styled-components';
import { primaryColor } from '~theme';

import activeSVG from '~images/checkbox_active.svg';
import inactiveSVG from '~images/checkbox_inactive.svg';

import InfoTooltip from '~components/InfoTooltip';

const Checkbox = ({ label, disabled, children, info, ...props }) => {
  const handleClick = event => {
    event.preventDefault();
    if (disabled) return;
    props.onChange(!props.value);
  };

  return (
    <Wrapper>
      <Controls role="button" onClick={handleClick}>
        <Icon disabled={disabled} src={props.value ? activeSVG : inactiveSVG} />
        {label && (
          <Label>
            <LabelText disabled={disabled}>{label}</LabelText>
            {info && (
              <InfoContainer>
                <InfoTooltip content={info} size="16px" />
              </InfoContainer>
            )}
          </Label>
        )}
      </Controls>
      {children && <Child>{children}</Child>}
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const Controls = styled.button`
  display: flex;
  align-items: center;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  margin: 0;
  padding: 0;
  // margin-bottom: 12px;
`;

const Icon = styled.img`
  ${props => props.disabled && 'filter: brightness(80%);'}
`;

const Label = styled.div`
  margin-left: 16px;
  font-size: 16px;
  font-weight: 100;
  user-select: none;
  text-align: left;
  color: ${primaryColor};
`;

const LabelText = styled.span``;

const Child = styled.div`
  margin-top: 24px;
  margin-left: 39px; // To line up with the checkbox
`;

const InfoContainer = styled.span`
  margin-left: 8px;

  & > * {
    // cursor: help;
  }
`;

export default Checkbox;
